import { makeAutoObservable } from "mobx";
import AuthStore from "./AuthStore";
import ProfileStore from "./ProfileStore";
import ServerStore from "./ServerStore";
import ChatStore from "./ChatStore";
import LogStore from "./LogStore";
import PlayerStore from "./PlayerStore";

export default class RootStore {
    constructor() {
        this.auth = new AuthStore();
        this.profile = new ProfileStore();
        this.server = new ServerStore();
        this.chat = new ChatStore();
        this.log = new LogStore();
        this.player = new PlayerStore();

        makeAutoObservable(this, {}, { autoBind: true });
    }

    resetAll() {
        this.auth.reset();
        this.profile.reset();
        this.server.reset();
        this.chat.reset();
        this.log.reset();
        this.player.reset();
    }
}
